import { render, staticRenderFns } from "./LegoControlCardEffort.vue?vue&type=template&id=3dd4b4e2&scoped=true"
import script from "./LegoControlCardEffort.vue?vue&type=script&lang=js"
export * from "./LegoControlCardEffort.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardEffort.vue?vue&type=style&index=0&id=3dd4b4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4b4e2",
  null
  
)

export default component.exports